import Button from '../Button/Button';

const ErrorPage = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24 text-center">
      <p className="text-[10rem] leading-none font-black tracking-tighter text-amber-900/20 select-none sm:text-[14rem]">
        :(
      </p>
      <h1 className="-mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:-mt-10">
        Une erreur est survenue
      </h1>
      <p className="mt-4 text-lg leading-7 text-gray-600">
        Une erreur inattendue s'est produite. Veuillez réessayer ou revenir à l'accueil.
      </p>
      <div className="mt-10 flex items-center gap-x-4">
        <Button size="lg" onClick={() => window.location.reload()}>
          Réessayer
        </Button>
        <Button size="lg" color="secondary" onClick={() => (window.location.href = '/')}>
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
